import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectors } from "reducers/patient-outreaches";
import {
  fetchEligibilityRules,
  fetchPatientOutreachCounts,
  fetchPatientOutreachFilterOptions,
  exportPatientOutreach
} from "actions/patient-outreaches";
import TotalCountsHeader from "./total-counts-header";
import PoolRules from "./pool-rules";
import FilterBar from "./filter-bar";
import Grid from "./grid";
import PatientLookupPanel from "./patient-lookup-panel";
import "./patient-outreaches.scss";

const PatientOutreaches = () => {
  const dispatch = useDispatch();
  const filters = useSelector(selectors.getFilters);
  const sort = useSelector(selectors.getSort);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    dispatch(fetchEligibilityRules());
    dispatch(fetchPatientOutreachFilterOptions());
  }, [dispatch]);

  // Counts re-fetch on every filter change so the tiles narrow alongside the grid
  // (S3DEV2-7602). Kept in a separate effect from the one-time fetches above so
  // filter churn doesn't re-fire eligibility-rule / filter-option loads.
  useEffect(() => {
    dispatch(fetchPatientOutreachCounts({ filters }));
  }, [dispatch, filters]);

  // Export uses the *applied* filters + sort so the CSV matches what the grid
  // shows across all pages. Guarded by isExporting so an impatient user can't
  // queue duplicate export jobs by clicking again before the redirect lands.
  // Only reset on failure — the success path navigates away and this component
  // unmounts, so setting state there would warn.
  const handleExport = async () => {
    if (isExporting) return;
    setIsExporting(true);
    try {
      await dispatch(
        exportPatientOutreach({
          filters,
          sortBy: sort.sortBy,
          sortDir: sort.sortDir
        })
      );
    } catch (e) {
      setIsExporting(false);
    }
  };

  return (
    <div className="patient-outreaches-page">
      <div className="patient-outreaches-page__title-row">
        <h1>Patient Call Pool</h1>
        <button
          type="button"
          className="button secondary"
          onClick={handleExport}
          disabled={isExporting}
        >
          {isExporting ? "Starting export…" : "Export CSV"}
        </button>
      </div>
      <TotalCountsHeader />
      <PatientLookupPanel />
      <PoolRules />
      <FilterBar />
      <Grid />
    </div>
  );
};

export default PatientOutreaches;
